import { CircleNotch } from "@phosphor-icons/react";
import { cn } from "@/lib/utils";

/**
 * Spinner reutilizable con tamaños s | m | l.
 * Úsalo inline dentro de botones o en estados de carga.
 */
export default function Spinner({ size = "m", className, label }) {
  const px = size === "s" ? 14 : size === "l" ? 28 : 18;
  return (
    <span
      role="status"
      aria-live="polite"
      className={cn("inline-flex items-center gap-2 text-muted-foreground", className)}
      data-testid="spinner"
    >
      <CircleNotch size={px} weight="bold" className="animate-spin text-primary" />
      {label && <span className="text-sm">{label}</span>}
    </span>
  );
}
